import { createReducer } from "@reduxjs/toolkit";
const initialState = {
    isLoading: false,
  };

  const pleadingsReducer = createReducer(initialState, (builder) => {
    builder
      .addCase("get_Fillter_pleadings_request", (state) => {
        state.isLoading = true;
      })
      .addCase("get_Fillter_pleadings_success", (state,action) => {
        state.isLoading = false;
        state.Fillterpleadings = action.payload.pleadings;
        state.pagination = action.payload.pagination;
      })
      .addCase("get_Fillter_pleadings_error", (state,action) => {
        state.isLoading = false;
        state.err = action.payload;
      })
      .addCase("get_User_pleadings_request", (state) => {
        state.isLoading = true;
      })
      .addCase("get_User_pleadings_success", (state,action) => {
        state.isLoading = false;
        state.Userpleadings = action.payload.pleadings;
        state.pagination = action.payload.pagination;
      })
      .addCase("get_User_pleadings_error", (state,action) => {
        state.isLoading = false;
        state.err = action.payload;
      })
      .addCase("get_pleading_request", (state) => {
        state.isLoading = true;
      })
      .addCase("get_pleading_success", (state,action) => {
        state.isLoading = false;
        state.pleadingData = action.payload;
      })
      .addCase("get_pleading_error", (state,action) => {
        state.isLoading = false;
        state.err = action.payload;
      });
  });
  
  export default pleadingsReducer;